import Image from 'next/image'
import Link from 'next/link'

import clsx from 'clsx'

import { buttonVariants } from '@infura/packages.ui/Button'

function Page404() {
  return (
    <div className='flex h-screen flex-col items-center justify-center' data-testid='404'>
      <div className='text-default m-auto mx-12 max-w-4xl text-center'>
        <Image alt='404' className='mx-auto mb-12' height={214} src='/svg/icons/MetaMask.svg' width={214} />
        <h1 className='text-4xl'>Whoops, something went wrong</h1>
        <p className='mt-4'>The page you are looking for doesn't exist or has been moved.</p>
        <Link className={clsx(buttonVariants({ theme: 'primary' }), 'mx-auto block w-fit')} href='/'>
          GO TO HOMEPAGE
        </Link>
      </div>
    </div>
  )
}

Page404._noLayout = true

export default Page404
